import { AppDao } from '@rock/db-admin';

const dao = new AppDao();

export const appEquipmentConfigState = dao.appEquipmentConfigAtom();
export const appTaskScreenConfigState = dao.appTaskScreenConfigAtom();
